<template>
  <div class="add-album-container">
    <header class="page-header">
      <h1 class="page-title">🎵 Add New Album</h1>
      <p class="page-description">Add a new album to your listening session with enhanced form experience</p>
    </header>
    
    <AlbumCreationForm />
  </div>
</template>

<script>
import AlbumCreationForm from '../components/forms/AlbumCreationForm.vue'

export default {
  name: 'AddAlbumPage',
  components: {
    AlbumCreationForm
  }
}
</script>

<style scoped>
/* Import the tier colors for consistency */
@import '../styles/tier-colors.css';

.add-album-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  padding: 2rem;
}

.page-header {
  text-align: center;
  margin-bottom: 2rem;
  padding: 2rem 0;
}

.page-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #f3f3f3;
  margin: 0 0 1rem 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.page-description {
  font-size: 1.125rem;
  color: #aaa;
  margin: 0;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.5;
}

/* Responsive design */
@media (max-width: 768px) {
  .add-album-container {
    padding: 1rem;
  }
  
  .page-title {
    font-size: 2rem;
  }
  
  .page-description {
    font-size: 1rem;
  }
}

/* High contrast mode support */
@media (prefers-contrast: high) {
  .page-title {
    text-shadow: none;
  }
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  .page-title {
    text-shadow: none;
  }
}
</style> 